import { createLine } from "editing/snapping/visualise";
import { Group } from "paper";
import * as React from "react";
export const createEmptyGlobalSnapViz = () => ({
    lines: []
});
/**
 * Visualizes snapping on a global level, e.g. when two rectangles are aligned,
 * there is a line drawn between them.
 */
export class GlobalSnapVizView extends React.Component {
    constructor(props) {
        super(props);
        this.group = new Group([]);
    }
    componentWillUnmount() {
        this.group.remove();
    }
    setViz(viz) {
        this.setState({ viz });
    }
    render() {
        var _a;
        this.group.removeChildren();
        const viz = (_a = this.state) === null || _a === void 0 ? void 0 : _a.viz;
        if (!viz) {
            return null;
        }
        for (let line of viz.lines) {
            this.group.addChild(createLine(line.start, line.end));
        }
        return null;
    }
}
